export default function CreateRefinedProjectsList(projects_list, propertyData) {

    // Function to get full climate risk data
    const getFullClimateRiskData = (riskName) => {
        return propertyData?.data?.climate_risks?.find(
            risk => risk.risk_name === riskName
        );
    };

    // Function to get house category data
    const getHouseCategoryData = (categoryName) => {
        return propertyData?.data?.property_areas_threatened?.house_categories_with_risks?.find(
            category => category.category === categoryName
        );
    };

    // Function to create the refined projects list
    const refinedProjects = projects_list.map(project => {

        // Get full climate risk data for each associated risk
        const enhancedClimateRisks = project.project_associated_climate_risks.map(riskName => {
            const fullRiskData = getFullClimateRiskData(riskName);
            if (!fullRiskData) return null;

            return {
                risk_name: fullRiskData.risk_name,
                risk_level: fullRiskData.risk_level,
                image: fullRiskData.image,
                icon_black: fullRiskData.icon_black,
                icon_white: fullRiskData.icon_white
            };
        }).filter(risk => risk !== null);

        // Get house category data
        const houseCategoryData = getHouseCategoryData(project.project_home_category);

        // Get the project total payback 
        const projectTotalPayback = project.project_payoff_by_scenario[0].by_total.total;

        // Get the project payback by year
        const projectPaybackByYear = project.project_payoff_by_scenario[0].by_total.by_year;

        // Get the project total cost
        const projectTotalCost = project.project_total_cost;

        // Get the project ROI
        const projectROI = (projectTotalPayback - projectTotalCost) / projectTotalCost;

        // Determine the year the project will payback
        const projectPaybackYear = project.project_payoff_by_scenario[0].roi_assessment.all_value_streams.breakeven_year;

        // Return project with enhanced data
        return {
            ...project,
            project_associated_climate_risks: enhancedClimateRisks,
            house_category_icon: houseCategoryData?.icon || null,
            house_category_image: houseCategoryData?.image || null,
            house_category_risk_level: houseCategoryData?.risk_level || "Low",
            project_total_payback: projectTotalPayback,
            project_payback_by_year: projectPaybackByYear,
            project_roi: projectROI,
            project_payback_year: projectPaybackYear
        };
    }) || [];

    return refinedProjects;
}